.highlight table td {
  padding: 5px;
}

.highlight table pre {
  margin: 0;
}

.highlight .cm {
  color: #999988;
  font-style: italic;
}

.highlight .cp {
  color: #999999;
  font-weight: bold;
}

.highlight .c1 {
  color: #999988;
  font-style: italic;
}

.highlight .cs {
  color: #999999;
  font-weight: bold;
  font-style: italic;
}

.highlight .c, .highlight .ch, .highlight .cd, .highlight .cpf {
  color: #999988;
  font-style: italic;
}

.highlight .err {
  color: #a61717;
  background-color: #e3d2d2;
}

.highlight .gd {
  color: #000000;
  background-color: #ffdddd;
}

.highlight .ge {
  color: #000000;
  font-style: italic;
}

.highlight .gr {
  color: #aa0000;
}

.highlight .gh {
  color: #999999;
}

.highlight .gi {
  color: #000000;
  background-color: #ddffdd;
}

.highlight .go {
  color: #888888;
}

.highlight .gp {
  color: #555555;
}

.highlight .gs {
  font-weight: bold;
}

.highlight .gu {
  color: #aaaaaa;
}

.highlight .gt {
  color: #aa0000;
}

.highlight .kc {
  color: #000000;
  font-weight: bold;
}

.highlight .kd {
  color: #000000;
  font-weight: bold;
}

.highlight .kn {
  color: #000000;
  font-weight: bold;
}

.highlight .kp {
  color: #000000;
  font-weight: bold;
}

.highlight .kr {
  color: #000000;
  font-weight: bold;
}

.highlight .kt {
  color: #445588;
  font-weight: bold;
}

.highlight .k, .highlight .kv {
  color: #000000;
  font-weight: bold;
}

.highlight .mf {
  color: #009999;
}

.highlight .mh {
  color: #009999;
}

.highlight .il {
  color: #009999;
}

.highlight .mi {
  color: #009999;
}

.highlight .mo {
  color: #009999;
}

.highlight .m, .highlight .mb, .highlight .mx {
  color: #009999;
}

.highlight .sa {
  color: #000000;
  font-weight: bold;
}

.highlight .sb {
  color: #d14;
}

.highlight .sc {
  color: #d14;
}

.highlight .sd {
  color: #d14;
}

.highlight .s2 {
  color: #d14;
}

.highlight .se {
  color: #d14;
}

.highlight .sh {
  color: #d14;
}

.highlight .si {
  color: #d14;
}

.highlight .sx {
  color: #d14;
}

.highlight .sr {
  color: #009926;
}

.highlight .s1 {
  color: #d14;
}

.highlight .ss {
  color: #990073;
}

.highlight .s, .highlight .dl {
  color: #d14;
}

.highlight .na {
  color: #008080;
}

.highlight .bp {
  color: #999999;
}

.highlight .nb {
  color: #0086B3;
}

.highlight .nc {
  color: #445588;
  font-weight: bold;
}

.highlight .no {
  color: #008080;
}

.highlight .nd {
  color: #3c5d5d;
  font-weight: bold;
}

.highlight .ni {
  color: #800080;
}

.highlight .ne {
  color: #990000;
  font-weight: bold;
}

.highlight .nf, .highlight .fm {
  color: #990000;
  font-weight: bold;
}

.highlight .nl {
  color: #990000;
  font-weight: bold;
}

.highlight .nn {
  color: #555555;
}

.highlight .nt {
  color: #000080;
}

.highlight .vc {
  color: #008080;
}

.highlight .vg {
  color: #008080;
}

.highlight .vi {
  color: #008080;
}

.highlight .nv, .highlight .vm {
  color: #008080;
}

.highlight .ow {
  color: #000000;
  font-weight: bold;
}

.highlight .o {
  color: #000000;
  font-weight: bold;
}

.highlight .w {
  color: #bbbbbb;
}

.highlight {
  background-color: #f8f8f8;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */